package fr.labodoc.healthProfessional.webApp.pages.aboutUs

import fr.labodoc.healthProfessional.webApp.Page
import fr.labodoc.healthProfessional.webApp.components.hr
import fr.labodoc.healthProfessional.webApp.components.labodocButton
import fr.labodoc.healthProfessional.webApp.components.navigoLink
import fr.labodoc.healthProfessional.webApp.components.swiperContainer
import fr.labodoc.require
import io.kvision.core.Container
import io.kvision.html.*
import io.kvision.panel.SimplePanel
import org.koin.core.component.KoinComponent

class AboutUsPage() : SimplePanel(), KoinComponent {

  init {
    id = "page-about-us"
    require("./css/pages/aboutUs/about-us.css")
    div(className = "labodoc-background-beige d-flex flex-row align-center pb-xs-6") {
      id = "page-about-header"

      div(className = "labodoc-background-beige col-xl-6 col-lg-6 col-12") {
        id = "page-about-presentation"

        div(className = "page-width d-flex flex-column pt-5 pt-lg-10 pt-xl-10 align-xs-center") {
          id = "page-about-presentation-content"

          h1 (className = "mb-8 text-xs-center mb-xs-4"){
            content = "A propos de Labodoc"
          }

          p (className= "mb-8 mb-xs-4", rich = true) {
            content = """
              <b>LaboDoc a été conçu pour accompagner les médecins dans l’exercice de leur métier</b>, en simplifiant l’accès à de multiples ressources médicales utiles à leur pratique.<br>
              Sociétés savantes, institutions, laboratoires… y partagent leurs actualités, recommandations, invitations et documents.
            """.trimIndent()
          }

          p (className= "mb-8 mb-xs-4", rich = true) {
            content = """
              <b>De votre côté, vous consultez ce qui vous intéresse, à votre rythme, sans sur-sollicitation</b>.
            """.trimIndent()
          }
        }
      }

      div (className = "col-xl-3 col-lg-3 hidden-sm-and-down") {
        div(className = "page-width") {
          image(require("./img/page-about-header.png"))
        }
      }
    }

    div(className = "labodoc-background-white py-lg-14 py-xl-16") {
      id = "page-about-pros"

      div(className = "page-width mx-lg-14 mx-xl-16") {
        h1 {
          content = "Nos engagements"
        }
        h4 {
          content = "Chez LaboDoc, nous accordons une importance primordiale à la fiabilité des informations qui vous sont présentées. Tous les documents diffusés respectent scrupuleusement les dispositions du Code de la Santé Publique, incluant le cas échéant un contrôle préalable de l’ANSM."
        }

        div(className = "d-flex justify-center hidden-sm-and-down") {
          div(className = "bubble col-4 labodoc-background-white") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Neutralité"
              }
            }

            div (className = "d-flex align-center justify-center") {
              p {
                content =
                  "Aucun contenu modifié, aucun acteur favorisé."
              }
            }
          }

          div(className = "bubble col-4 labodoc-background-white") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Transparence"
              }
            }

            div (className = "d-flex align-center justify-center") {
              p {
                content = "Toutes les sources sont identifiées et vérifiables."
              }
            }
          }

          div(className = "bubble col-4 labodoc-background-white") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Confidentialité"
              }
            }

            div (className = "d-flex align-center justify-center") {
              p {
                content =
                  "Aucune donnée individuelle collectée, navigation privée."
              }
            }
          }

          div(className = "bubble col-4 labodoc-background-white") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Simplicité"
              }
            }

            div (className = "d-flex align-center justify-center") {
              p {
                content =
                  "Deux clics suffisent pour accéder à l’essentiel."
              }
            }
          }
        }
      }

      div(className = "mobile swiper") {
        swiperContainer(className = "swiper-wrapper mb-6") {
          setAttribute("slides-per-view", "auto")
          setAttribute("centered-slides", "true")
          setAttribute("pagination", "true")
          setAttribute("pagination-dynamic-bullets", "true")

          slide(className = "bubble labodoc-background-white swiper-slide") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Neutralité"
              }
            }
            div (className = "d-flex align-center justify-center") {
              p {
                content =
                  "Aucun contenu modifié, aucun acteur favorisé."
              }
            }
          }

          slide(className = "bubble labodoc-background-white") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Transparence"
              }
            }

            div (className = "d-flex align-center justify-center") {
              p {
                content = "Toutes les sources sont identifiées et vérifiables."
              }
            }
          }

          slide(className = "bubble labodoc-background-white swiper-slide") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Confidentialité"
              }
            }
            div (className = "d-flex align-center justify-center") {
              p {
                content =
                  "Aucune donnée individuelle collectée, navigation privée."
              }
            }
          }

          slide(className = "bubble labodoc-background-white swiper-slide") {
            div (className = "d-flex align-center justify-center") {
              div (className = "pros-point-icon mr-3") {  }
              h2 {
                content = "Simplicité"
              }
            }
            div (className = "d-flex align-center justify-center") {
              p {
                content =
                  "Deux clics suffisent pour accéder à l’essentiel."
              }
            }
          }
        }
      }
    }

    div(className = "labodoc-background-light-blue") {
      id = "page-about-features"

      div(className = "page-width") {
        div (className = "order-md-last d-flex justify-center align-center") {
          image(require("./img/page-about-doctor.png"))
        }
        div {
          h1 {
            content = "Ce que vous y trouverez"
          }
          hr(className = "mb-xl-10 mb-lg-8") {}

          ul {
            li {
              content = "Un fil d’actualité personnalisé selon vos centres d’intérêt"
            }

            li {
              content = "Des fiches médicaments organisées par thématiques"
            }

            li {
              content = "De nombreux liens utiles pour approfondir vos recherches : sociétés savantes, sites institutionnels ..."
            }

            li {
              content = "Des communications proposées par les laboratoires, accessibles librement et anonymement"
            }
          }
        }
      }
    }

    div(className = "labodoc-background-white px-lg-12 px-xl-16 py-10") {
      id = "page-about-mission"

      div(className = "page-width mx-lg-12 mx-xl-16") {
        h1 (className = "mx-5") {
          content = "Pourquoi utiliser LaboDoc ?"
        }
        div {
          p {
            rich = true
            content = """
                <i>"Parce que l’information est utile… seulement si elle est simple à consulter"</i>.<br>
                <br>
                <b>LaboDoc vous aide à gagner en efficacité</b>, en rendant accessibles des ressources précieuses souvent difficiles à retrouver.<br>
                <b>Gratuit et centré sur vos besoins</b>, LaboDoc s’adapte à votre pratique — et vous laisse libre de tout choisir, y compris ce que vous consultez.
              """.trimIndent()
          }
        }
        navigoLink("", Page.Register()) {
          labodocButton("Je m'inscris gratuitement", className = "labodoc-background-middle-blue mb-xl-6 mb-lg-4")
        }
      }
    }

    val swiper = require("swiper/element/bundle")

    swiper.register()
  }
}

fun Container.aboutUsPage(): AboutUsPage {
  val aboutUsPage = AboutUsPage()

  this.add(aboutUsPage)
  return aboutUsPage
}
